export default "__VITE_ASSET__Cse5P7dj__"